export enum IMAGE_FILE_FORMATS {
  JPG = 'image/jpeg',
  PNG = 'image/png'
}
